import { jsx as e } from "react/jsx-runtime";
import { forwardRef as p, useMemo as s } from "react";
import { Link as t } from "./index.es68.js";
import { CopyToClipboard as a } from "./index.es165.js";
import { BodyText as l } from "./index.es505.js";
const w = p(
  ({ value: o, type: n, testId: r }, i) => {
    const m = s(() => ({
      phoneNumber: /* @__PURE__ */ e(
        a,
        {
          tooltipText: { beforeCopy: "Click to copy", afterCopy: "Copied!" },
          copyTarget: "text",
          color: "gray",
          icon: { hasIcon: !0, showOnHover: !0, position: "end" },
          testId: r,
          children: o
        }
      ),
      text: /* @__PURE__ */ e(l, { ref: i, size: "small", variant: "semi-bold", testId: r, children: o }),
      link: /* @__PURE__ */ e(
        t,
        {
          href: `http://www.${o}`,
          color: "brand",
          size: "small",
          weight: "semi-bold",
          isEllipsis: !0,
          target: "_blank",
          ref: i,
          testId: r,
          children: o
        }
      ),
      email: /* @__PURE__ */ e(
        t,
        {
          href: `mailto:${o}`,
          color: "brand",
          size: "small",
          weight: "semi-bold",
          isEllipsis: !0,
          ref: i,
          testId: r,
          children: o
        }
      )
    }), [i, r, o]);
    return o ? m[n] : /* @__PURE__ */ e(l, { variant: "semi-bold", testId: r + "-separated", children: "-" });
  }
);
export {
  w as DetailValue
};
//# sourceMappingURL=index.es5596.js.map
